import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {HomepageDialog, homepageStore} from '../../store/HomepageStore';
import {AddPortletDialog} from './components/AddPortletDialog';
import {GroupDialog} from './components/GroupDialog/GroupDialog';
import {AddTileDialog} from './components/AddTileDialog';
import {DeleteGroupDialog} from './components/DeleteGroupDialog/DeleteGroupDialog';
import {CopyHomepageDialog} from './components/CopyHomepageDialog/CopyHomepageDialog';
import {addPortlet, addTile, closeAddToHomepageDialog, removeGroup} from '../../actions/dialogs';
import {AddToHomepageDialog} from './components/AddToHomepageDialog/AddToHomepageDialog';
import {DefaultGroupsIDs} from '../../enums';
import {showFormClientSideMessage} from '../../../../features/Form/actions/messages';
import texts from '../../texts';

export const HomepageDialogs = observer(() => {
    const {
        showDialog,
        dialogType,
        portlets,
        groups,
        closeDialog,
        selectedGroup,
        addedItemFromMenu
    } = homepageStore;

    const saveGroup = useCallback(
        async (title: string, id: string) => {
            if (!homepageStore.groups.has(title)) {
                await homepageStore.addGroup(title, id);
                closeDialog();
            } else {
                showFormClientSideMessage('', priority.netitems.shared.Message.Type.Error, {
                    title: texts.group_name_exists_dialog_title,
                    content: texts.group_name_exists_dialog_instructions,
                    confirmButtonText: texts.group_name_exists_dialog_confirm
                });
            }
        },
        [closeDialog]
    );

    if (showDialog) {
        if (dialogType === HomepageDialog.addPortlet) {
            const addedPortletsData = (groups.get(DefaultGroupsIDs.insights)?.items || []).map(
                item => item.exec
            );
            const data = portlets.filter(portlet => !addedPortletsData.includes(portlet.exec));

            return <AddPortletDialog data={data} closeDialog={closeDialog} onSave={addPortlet} />;
        } else if (dialogType === HomepageDialog.addGroup) {
            return (
                <GroupDialog onClose={closeDialog} onSave={saveGroup} defaultName={selectedGroup} />
            );
        } else if (dialogType === HomepageDialog.removeGroup) {
            return (
                <DeleteGroupDialog
                    onClose={closeDialog}
                    onAccept={removeGroup}
                    groupName={selectedGroup}
                />
            );
        } else if (dialogType === HomepageDialog.addTile) {
            return (
                <AddTileDialog onClose={closeDialog} onSave={addTile} groupName={selectedGroup} />
            );
        } else if (dialogType === HomepageDialog.copyHomepage) {
            return <CopyHomepageDialog onClose={closeDialog} />;
        } else if (dialogType === HomepageDialog.addToHomePage) {
            return (
                <AddToHomepageDialog
                    onClose={closeAddToHomepageDialog}
                    itemToAdd={addedItemFromMenu}
                />
            );
        }
    }

    return null;
});
